export type CriticalWriteDeliveryState = "PREPARED" | "SENDING" | "OUTCOME_UNKNOWN" | "REMOTE_CONFIRMED";

const uncertainCodes = new Set([
  "OPERATION_OUTCOME_UNKNOWN",
  "CLIENT_REQUEST_TIMEOUT",
  "NETWORK_ERROR",
  "INVALID_API_RESPONSE",
]);
const definitiveDomainCodes = new Set([
  "FORBIDDEN",
  "HISTORICAL_SCRAP_APPROVAL_REQUIRED",
  "PRODUCTION_CONFLICT",
  "PRODUCTION_IDEMPOTENCY_MISMATCH",
  "PRODUCTION_MATERIAL_CONTEXT_CHANGED",
  "PRODUCTION_MATERIAL_CONTEXT_UNAVAILABLE",
  "PRODUCTION_MATERIAL_INVALID",
  "PRODUCTION_NOT_FOUND",
  "PRODUCTION_RUN_VERSION_CHANGED",
  "PRODUCTION_SESSION_CHANGED",
  "PRODUCTION_TERMINAL_REQUIRED",
  "PRODUCTION_UNIT_CONTRACT_CHANGED",
  "PRODUCTION_UNIT_FACTOR_REQUIRED",
  "PRODUCTION_UNIT_INVALID",
  "PRODUCTION_UNIT_UNAVAILABLE",
  "PRODUCTION_VALIDATION_ERROR",
]);

/** Only a first-attempt, explicit non-5xx API rejection proves this write was not committed. */
export function criticalWriteFailureAction(
  stateBeforeAttempt: CriticalWriteDeliveryState,
  error: unknown,
): "REMOVE" | "RETAIN" {
  if (stateBeforeAttempt !== "PREPARED" || !(error instanceof Error) || error.name !== "ApiError") return "RETAIN";
  const code = "code" in error && typeof error.code === "string" ? error.code : null;
  if (!code || uncertainCodes.has(code)) return "RETAIN";
  if (/^HTTP_4\d\d$/u.test(code) && code !== "HTTP_408" && code !== "HTTP_425") return "REMOVE";
  return definitiveDomainCodes.has(code) ? "REMOVE" : "RETAIN";
}
